import React from "react";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import Home from "./HomePage";
import DemoPage from "./DemoPage";
import SubscribePage from "./SubscribePage";
import ThankYouPage from "./ThankYouPage";
import LearnMorePage from "./LearnMorePage";
import "./styles.css";

import MainLayout from "./MainLayout";

export default function App() {
  return (
    <BrowserRouter>
      <MainLayout>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/Demo/:race" component={DemoPage} />
          <Route
            path="/Review"
            component={props => (
              <SubscribePage title="Thanks for voting!" {...props} />
            )}
          />
          <Route
            path="/Subscribe"
            component={props => (
              <SubscribePage title="Get Election Results" {...props} />
            )}
          />
          <Route path="/Subscribe" component={SubscribePage} />
          <Route path="/ThankYou" component={ThankYouPage} />
          <Route path="/Learn" component={LearnMorePage} />
          <Redirect from="*" to="/" />
        </Switch>
      </MainLayout>
    </BrowserRouter>
  );
}
